function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fillnone;}.cls-1,.cls-3{stroke#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit10;}.cls-2{stroke#ac893a;stroke-width2.92px;}.cls-3{fill#ac893a;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "menu_grafika_intensywny");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.69 1.0107)",
  shapeRendering: "auto"
}, /*#__PURE__*/React.createElement("path", {
  d: "m76.311 153.06c-22.781 0-41.281 18.498-41.281 41.279s18.5 41.279 41.281 41.279 41.279-18.498 41.279-41.279-18.498-41.279-41.279-41.279zm0 2.9199c21.203 0 38.359 17.156 38.359 38.359s-17.156 38.359-38.359 38.359-38.361-17.156-38.361-38.359 17.158-38.359 38.361-38.359z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  fill: "#ac893a",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.311 152.41c-22.781 0-41.281 18.498-41.281 41.279s18.5 41.281 41.281 41.281 41.279-18.5 41.279-41.281-18.498-41.279-41.279-41.279zm0 2.9199c21.203 0 38.359 17.156 38.359 38.359s-17.156 38.361-38.359 38.361-38.361-17.158-38.361-38.361 17.158-38.359 38.361-38.359z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  fill: "#ac893a",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.961 0v146.16h34.84v-146.16h-1v145.16h-32.84v-145.16z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-76.49,-30.54)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m152.8 145.41c-30.662 0-58.306 18.471-70.039 46.798-11.733 28.328-5.2457 60.933 16.436 82.615 21.681 21.681 54.287 28.169 82.615 16.436s46.798-39.377 46.798-70.039c0.0221-41.878-33.932-75.832-75.81-75.81z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  fill: "#ac893a",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m152.8 144.91c-30.862 7.9e-4 -58.69 18.595-70.5 47.107-11.81 28.513-5.2784 61.335 16.545 83.158 21.823 21.823 54.647 28.355 83.16 16.545s47.105-39.637 47.105-70.5c0.0222-42.148-34.161-76.332-76.309-76.311h-2e-3zm2e-3 1c41.607-0.022 75.331 33.703 75.309 75.311 0 30.461-18.346 57.92-46.488 69.576s-60.531 5.2113-82.07-16.328c-21.539-21.539-27.985-53.926-16.328-82.068 11.656-28.142 39.117-46.49 69.578-46.49z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-76.49,-30.54)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m227.88 183c-0.0715 9.2685-7.6112 16.741-16.88 16.73-4.5082 0.0685-8.8466-1.7175-12-4.94-3.2779-3.0829-5.0949-7.4111-5-11.91-0.0666-4.5344 1.7427-8.8948 5-12.05 3.0935-3.2558 7.4203-5.0504 11.91-4.94 9.4768-0.08 17.158 7.6642 17 17.14z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m210.91 165.39c-4.6237-0.11149-9.0793 1.7376-12.268 5.0879-3.3498 3.2486-5.2129 7.7345-5.1465 12.4-0.095 4.6357 1.7791 9.096 5.1562 12.273 6.8e-4 6.4e-4 1e-3 1e-3 2e-3 2e-3 3.2479 3.3109 7.7116 5.1466 12.35 5.0762 9.1621 7e-3 16.617-7.1242 17.256-16.141l0.12695 0.12696 0.0195-1.1777c0.16225-9.7478-7.7483-17.726-17.496-17.648zm-0.0156 1h0.016c9.0925-0.0768 16.442 7.2597 16.469 16.311l-2e-3 0.29492c-0.0694 8.9995-7.3812 16.245-16.381 16.234h-8e-3c-4.3713 0.0664-8.5772-1.6664-11.635-4.791l-8e-3 -6e-3 -8e-3 -8e-3c-3.1749-2.9861-4.9337-7.1776-4.8418-11.535v-0.018c-0.0646-4.3967 1.6893-8.6242 4.8477-11.684l0.0156-0.0156c2.9963-3.1535 7.1864-4.8902 11.535-4.7832z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-76.49,-30.54)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m227.88 244.45c-0.0824 9.2607-7.619 16.721-16.88 16.71-4.5082 0.0685-8.8466-1.7175-12-4.94-3.2779-3.0829-5.0949-7.4111-5-11.91-0.0666-4.5344 1.7427-8.8948 5-12.05 3.0935-3.2558 7.4203-5.0504 11.91-4.94 9.4768-0.08 17.158 7.6642 17 17.14z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m210.91 226.82c-4.6242-0.1115-9.0812 1.7369-12.27 5.0879-3.3493 3.2485-5.2109 7.7349-5.1445 12.4-0.095 4.6357 1.7791 9.096 5.1562 12.273 6.8e-4 6.4e-4 1e-3 1e-3 2e-3 2e-3 3.2479 3.3109 7.7116 5.1467 12.35 5.0762 9.2987 7e-3 16.863-7.3309 17.301-16.541l0.0898 0.0312 0.0117-0.68164c0.16225-9.7478-7.7483-17.726-17.496-17.648zm-0.0156 1h0.016c9.0951-0.0768 16.446 7.2639 16.469 16.318l-2e-3 0.30664c-0.08 8.9918-7.3887 16.226-16.381 16.215h-8e-3c-4.3713 0.0664-8.5772-1.6644-11.635-4.7891l-0.0156-0.0156c-3.1749-2.9861-4.9337-7.1776-4.8418-11.535v-0.018c-0.0646-4.3967 1.6893-8.6242 4.8477-11.684l0.0156-0.0156c2.9963-3.1535 7.1864-4.8902 11.535-4.7832z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-76.49,-30.54)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m227.88 121.45c-0.0878 9.2568-7.6228 16.711-16.88 16.7-4.5067 0.0711-8.8449-1.7112-12-4.93-3.2779-3.0829-5.0949-7.4111-5-11.91-0.0694-4.5378 1.7402-8.9025 5-12.06 3.0935-3.2558 7.4203-5.0504 11.91-4.94 4.5254-0.0823 8.8846 1.7048 12.05 4.94 3.2331 3.2269 5.01 7.633 4.92 12.2z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m210.91 103.81c-4.6223-0.11036-9.0763 1.7385-12.264 5.0879-3.352 3.2506-5.2152 7.7414-5.1465 12.41-0.095 4.6357 1.7791 9.096 5.1562 12.273 6.8e-4 6.4e-4 1e-3 1e-3 2e-3 2e-3 3.2496 3.3071 7.7131 5.1396 12.35 5.0664 9.521 7e-3 17.281-7.6704 17.373-17.191 0.0927-4.703-1.739-9.2396-5.0684-12.562-3.2588-3.3279-7.7454-5.1679-12.402-5.0859zm-0.0117 1h0.0217c4.388-0.0798 8.6143 1.6521 11.684 4.7891l4e-3 4e-3c3.1369 3.1308 4.8608 7.4049 4.7734 11.836v6e-3c-0.0853 8.988-7.3924 16.216-16.381 16.205h-8e-3c-4.3698 0.069-8.5755-1.6602-11.635-4.7812l-8e-3 -6e-3 -8e-3 -8e-3c-3.1749-2.9861-4.9337-7.1776-4.8418-11.535v-0.018c-0.0673-4.4 1.6868-8.6317 4.8477-11.693l0.016-0.016c2.9963-3.1535 7.1864-4.8902 11.535-4.7832z",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  imageRendering: "auto",
  "solid-color": "#000000",
  stopColor: "#000000"
})));

var SvgKursIntensywny = function SvgKursIntensywny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 200 268",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKursIntensywny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kurs_intensywny.9a495512.svg";
export { ForwardRef as ReactComponent };